<!-- Bootstrap 5 Optimized Content Container -->
<div class="content-wrapper h-100 d-flex flex-column overflow-hidden">
  <div class="container-fluid flex-grow-1 overflow-auto p-3">
    <!-- Router outlet for dynamic page content -->
    <router-outlet></router-outlet>
  </div>
</div>
